import { Breadcrumb, Button, Tabs, Typography } from "antd";
import { useLoaderData, useNavigate } from "react-router-dom";
import BuildingDetailsTab from "./components/BuildingDetailsTab/BuildingDetailsTab";
import { BuildingDetailsPageLoaderType } from "./loaders";
import { getRouteWithParams, ROUTES } from "~/utils";
import { HomeOutlined } from "@ant-design/icons";
import { useAppTranslation } from "~/hooks/useAppTranslation";

const BuildingDetailsPage = () => {
  const loaderData = useLoaderData() as BuildingDetailsPageLoaderType;
  const { t } = useAppTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Breadcrumb
        separator=">"
        items={[
          {
            key: "home",
            title: <HomeOutlined />,
            href: ROUTES.home,
          },
          {
            key: "building",
            title: t("Building"),
          },
        ]}
      />

      <Typography.Title level={1}>
        {t("Building")}: {loaderData.buildingDetails.name}
        <Typography.Paragraph type="secondary">
          {loaderData.buildingDetails.street}, {loaderData.propertyDetails.city}
          , {loaderData.propertyDetails.state},{" "}
          {loaderData.propertyDetails.country},{" "}
          {loaderData.propertyDetails.zipCode}
          {`${t("PO_Box")}: ` && loaderData.propertyDetails.poBox}
        </Typography.Paragraph>
      </Typography.Title>

      {loaderData.leases && loaderData.leases.length > 0 ? (
        <Button
          type="primary"
          ghost
          onClick={() => {
            navigate(ROUTES.lease);
          }}
        >
          {t("View_Lease_Applications")}
        </Button>
      ) : (
        <Button
          type="primary"
          ghost
          onClick={() => {
            navigate(
              getRouteWithParams("leaseApplication", {
                entityType: "Building",
                entityID: loaderData.buildingDetails.id,
              })
            );
          }}
        >
          {t("Apply_for_Lease")}
        </Button>
      )}

      <Tabs
        items={[
          {
            label: t("Details"),
            key: "details",
            children: (
              <BuildingDetailsTab
                buildingDetails={loaderData.buildingDetails}
                propertyDetails={loaderData.propertyDetails}
              />
            ),
          },
        ]}
      />
    </>
  );
};

export default BuildingDetailsPage;
